import React from 'react'
import './ShortIndustriesServed.css'
export default function ShortIndustriesServed() {
    // Industry data
    const industriesData = [
        { name: 'Port', image: require('../../assets/images/port1.jpg') },
        { name: 'Transport', image: require('../../assets/images/transport1.jpg') },
        { name: 'Energy & Power', image: require('../../assets/images/energy&power1.jpg') },
        { name: 'Mining', image: require('../../assets/images/mining1.jpg') },
        { name: 'Copper', image: require('../../assets/images/copper1.jpg') },
        { name: 'Steel', image: require('../../assets/images/steel1.jpg') },
        { name: 'Aluminum', image: require('../../assets/images/aluminium1.jpg') },
        // { name: 'Buildings', image: require('../../assets/images/buildings1.jpg') },
        { name: 'Hospital', image: require('../../assets/images/medical1.jpg') },
        { name: 'Diagnostic Centre', image: require('../../assets/images/diagnoticcentre1.jpg') },
        { name: 'Pharma', image: require('../../assets/images/pharma1.jpg') },
        { name: 'Real Estate', image: require('../../assets/images/buildings1.jpg') },
        { name: 'Construction', image: require('../../assets/images/construction1.jpg') },
        { name: 'Telecom', image: require('../../assets/images/telecom1.jpg') },
        { name: 'IT', image: require('../../assets/images/it1.jpg') },
        { name: 'Fertilizer', image: require('../../assets/images/fertilizer1.jpg') },
        { name: 'Petroleum', image: require('../../assets/images/petroleum1.jpg') },
    ];
    return (
        <>
            <section className="industries-served_iw1">
                <div className="container_iw1">
                    <h1 className="section-title1_iw1">Industries We Serve</h1>
                    <p className="section-description_iw1">
                        Since 2015, SARS India Liaison Pvt. Ltd. has provided single-window solutions across diverse industries, offering expertise to national and international organizations.
                    </p>
                    <div className="industries-grid_iw1">
                        {industriesData.map((industry, index) => (
                            <div className="industry-card_iw1" key={index}>
                                <div className="image-container_iw1">
                                    <img src={industry.image} alt={industry.name} className="industry-image_iw1" />
                                </div>
                                <div className="industry-name_iw1">{industry.name}</div>
                            </div>
                        ))}
                    </div>
                </div>
            </section>


        </>
    )
}
